// extracted by mini-css-extract-plugin
module.exports = {"QuizList":"QuizList_QuizList__15_Fa"};